module.exports = __webpack_public_path__ + "static/media/speedometer-653246_1920_2.1f265e3a.jpg";